import mergeSmimeDecodedMessageProperties from '../actions/mergeSmimeDecodedMessageProperties';
import mergeRecipientsFromMime, { mergeRecipientFromMime } from '../utils/mergeRecipientsFromMime';
import Message from 'owa-service/lib/contract/Message';
import singleRecipientType from 'owa-service/lib/factory/singleRecipientType';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';

/**
 * once S/MIME is decoded successfully
 */
const mergeSmimeDecodedMessagePropertiesMutator = mutator(
    mergeSmimeDecodedMessageProperties,
    actionMessage => {
        const message: Message = actionMessage.message;
        const smimeMessage: Message = actionMessage.smimeMessage;
        if (!message) {
            trace.error('SmimeTraceError: Item being merged should exist');
            return;
        }

        if (smimeMessage.From?.Mailbox) {
            if (message.From) {
                message.From.Mailbox = mergeRecipientFromMime(
                    smimeMessage.From.Mailbox,
                    message.From.Mailbox
                );
            } else {
                message.From = singleRecipientType(smimeMessage.From.Mailbox);
            }
        }

        if (smimeMessage.Sender?.Mailbox) {
            if (message.Sender) {
                message.Sender.Mailbox = mergeRecipientFromMime(
                    smimeMessage.Sender.Mailbox,
                    message.Sender.Mailbox
                );
            } else {
                message.Sender = singleRecipientType(smimeMessage.Sender.Mailbox);
            }
        }

        if (smimeMessage.ToRecipients) {
            message.ToRecipients = mergeRecipientsFromMime(
                smimeMessage.ToRecipients,
                message.ToRecipients
            );
        }

        if (smimeMessage.CcRecipients) {
            message.CcRecipients = mergeRecipientsFromMime(
                smimeMessage.CcRecipients,
                message.CcRecipients
            );
        }

        message.Subject = smimeMessage.Subject || message.Subject;
        message.Importance = smimeMessage.Importance || message.Importance;
        message.Sensitivity = smimeMessage.Sensitivity || message.Sensitivity;
        message.DateTimeSent = smimeMessage.DateTimeSent || message.DateTimeSent;

        message.NormalizedBody = smimeMessage.NormalizedBody;

        // Append attachments array to avoid clearing of p7m file for draft scenario.
        // We need the attachment information of p7m attachment to delete the attachment when we toggle to non-S/MIME mode.
        if (message.IsDraft && smimeMessage.Attachments && smimeMessage.Attachments.length) {
            message.Attachments.push(...smimeMessage.Attachments);
        } else {
            message.Attachments = smimeMessage.Attachments;
        }
    }
);

export default mergeSmimeDecodedMessagePropertiesMutator;
